module.exports = __webpack_public_path__ + "img/gusto.03773f48.webp";